import React from 'react';
import {
    Routes,
    Route
} from "react-router-dom";

import Home from '../components/Home'
import Upload from '../components/upload/Upload'
import UploadImage from '../components/upload/UploadImage'
import List from '../components/list/List'
import ListDetials from '../components/list/ListDetails'
import { Header } from '../common/Header'
import ScanImage from '../components/scan/ScanImage'

export default function AppRoutes() {

    React.useEffect(() => {

        if (!localStorage.getItem('org_url')) {
            localStorage.setItem('org_url', window.location.href)

        }

    }, []);

    return (
        <>
            <Header />
            <Routes>
                <Route path="/" element={<Home />}></Route>
                {/* <Route path="/" render={({ history }) => (<Home />)}></Route> */}
                <Route path="/upload" element={<Upload />} />
                <Route path="/upload/image" element={<UploadImage />} />
                <Route path="/list" element={<List />} />
                <Route path="/list/:id" element={<ListDetials />} />
                <Route path="/scan-youface" element={<ScanImage />} ></Route>
            </Routes>
        </>

    );

}
